/** Merges the current form resource into the store list (replace by id, or append if new). */
export const mergeCurrentResource = <T extends { id: string }>(
  storedResources: T[],
  currentResource?: T,
): T[] => {
  if (!currentResource?.id) {
    return storedResources;
  }

  const isAlreadyInStore = storedResources.some(
    (resource) => resource.id === currentResource.id,
  );

  if (isAlreadyInStore) {
    return storedResources.map((resource) =>
      resource.id === currentResource.id ? currentResource : resource,
    );
  }

  return [...storedResources, currentResource];
};
